export const RETRY_WAIT = 5000
// Max retries at RETRY_WAIT before showing the backend-unavailable screen.
export const RETRY_MAX_COUNT = 5
// Retry interval used while the backend-unavailable screen is shown.
export const RETRY_WAIT_LONG = 30000
export const STANDALONE_WORKSPACE_ID = 1
